import { numberFormatters } from "common/number-formatters";
import { NumberFormatKind } from "common/types";
export const getVariationClassName = (variation) => {
    if (!variation) {
        return "variation-cell-zero";
    }
    const formattedNumber = numberFormatters(variation, NumberFormatKind.percent);
    if (formattedNumber === "0%") {
        return "variation-cell-zero";
    }
    const signClass = formattedNumber.startsWith("-") || formattedNumber.startsWith("(") ? "negative" : "positive";
    return `variation-cell-${signClass}`;
};
